<template>
    <div class="specificInfo" :class="{warning: isWarning}">
        <h3 class="uni-body">
            {{ title }}
        </h3>
        <p class="uni-caption">
            {{ description }}
        </p>
    </div>
</template>

<script>
    export default {
        name: "SpecificInfo",
        props:{
            isWarning: Boolean,
            title: String,
            description: String,
        }
    }
</script>

<style scoped lang="scss">
    .specificInfo{
        color: var(--color-success-dark);
        background: var(--color-color-success-light);
        border-radius: var(--s-xxs);
        padding: var(--s-s);
        margin-top: var(--s-s);
        .uni-body{
            margin-bottom: 0;
        }
        &.warning{
            color: var(--color-warning-dark);
            background: var(--color-warning-light);
            a{
                color: var(color-warning-dark);
                background: var(color-warning-light);
            }
        }
        a{
            color: var(color-success-dark);
            background: var(color-success-light);
            text-decoration: underline;
        }
    }
</style>
